import React from 'react';
import PropTypes from 'prop-types';
import { EditorState, Modifier } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import isEmpty from 'lodash/isEmpty';
import styles from '../shared/styles';
import { RowDivision, DivisionLabel, HelperText } from '../shared/styled-components';
import EmbedderToolbar from '../shared/Editor/Embedder';
import ImageToolbar from '../shared/Editor/Image';
import { customBlockRenderFunc } from '../shared/Editor/utils';
import { DraftEditorWrapper } from '../../../../styles/styled';

const Description = (props) => {
  const {
    id,
    label,
    value,
    required,
    richEditor,
    placeholder,
    helper,
    onChange,
    maxlength,
  } = props;

  const requiredRender = (required) ? (
    <span style={styles.inputLabelRequire}>*</span>
  ) : null;

  const helperRender = (!isEmpty(helper)) ? (
    <HelperText>{helper}</HelperText>
  ) : null;

  return (
    <RowDivision className="row">
      <div id={id} className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
        <DivisionLabel>
          {label} {requiredRender}
        </DivisionLabel>
        {!richEditor && (
          <textarea
            type="text"
            style={styles.inputDescription}
            placeholder={placeholder}
            onChange={onChange}
            value={value}
            maxLength={maxlength}
          />
        )}
        {richEditor && (
          <DraftEditorWrapper>
            <Editor
              editorState={value}
              editorStyle={styles.editorStyle}
              onEditorStateChange={onChange}
              stripPastedStyles={true}
              toolbar={{
                embedded: {
                  component: EmbedderToolbar,
                  defaultSize: {
                    width: 855,
                    height: 490,
                  },
                },
                image: {
                  component: ImageToolbar,
                  alignmentEnabled: true,
                  defaultSize: {
                    width: 500,
                  }
                }
              }}
              customBlockRenderFunc={customBlockRenderFunc}
              readOnly={false}
            />
          </DraftEditorWrapper>
        )}
        {helperRender}
      </div>
    </RowDivision>
  );
};

Description.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  required: PropTypes.bool,
  richEditor: PropTypes.bool,
  placeholder: PropTypes.string,
  helper: PropTypes.string,
  onChange: PropTypes.func,
  maxlength: PropTypes.number,
};

Description.defaultProps = {
  id: 'description',
  label: 'Description',
  value: {},
  required: false,
  richEditor: false,
  placeholder: '',
  helper: '',
  onChange: () => {},
  maxlength: 300,
};

export default Description;
